import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "invitation" }
const _hoisted_2 = { class: "invitation-body" }
const _hoisted_3 = { class: "list-item-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonElement = _resolveComponent("ButtonElement")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.invite.team_name), 1),
      (!_ctx.hasTeam && !_ctx.hasEnded)
        ? (_openBlock(), _createBlock(_component_ButtonElement, {
            key: 0,
            theme: "outline-light",
            type: "button",
            loading: _ctx.loading,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doAcceptInvite()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('modals.invitations.accept')), 1)
            ]),
            _: 1
          }, 8, ["loading"]))
        : _createCommentVNode("", true)
    ])
  ]))
}